
import { IntlProvider, useIntl, FormattedMessage } from 'react-intl';
import {useState} from "react";
import DatePicker from '@ui-components/DatePicker';

const localeMapper = {
  it: "it-IT",
  en: "en-EN"
}

const MTDateRangePicker = ({
	initialStartDate,
	initialEndDate,
	onChangeStartDate,
	onChangeEndDate,
	onFilterChanged,
	columnDef,
	stacked = false,
	materialTable = true,
	labels = null
}) => {
	const [startDate, setStartDate] = useState(initialStartDate);
	const [endDate, setEndDate] = useState(initialEndDate);

	const intl = useIntl();
	return <IntlProvider   // IntlProvider is needed to translate the date in DatePicker components
		messages={localeMapper[localStorage.getItem("lang")]}
		locale={localStorage.getItem("lang")}
		defaultLocale="it"
	>
		<div className={`flex grid grid-cols-${stacked ? '1' : '2'} gap-x-1 ${labels?.startDate || labels?.endDate?'mb-4':''}`}>
			<DatePicker
				{...(labels?.startDate ? {label: labels.startDate} :{})}
				value={startDate}
				onChange={(date) => {
					setStartDate(date)
					onChangeStartDate(date)
					if (onFilterChanged) {
						onFilterChanged(columnDef.tableData.id,{
							startDate: date,
							endDate: endDate
						})
					}
				}}
				minDate={new Date(2022, 0, 1)}
				maxDate={endDate? endDate: new Date()}
				materialTable={materialTable}
				zIndexVal={2}
			/>
			<DatePicker
				{...(labels?.endDate ? {label: labels.endDate} :{})}
				value={endDate}
				onChange={(date) => {
					setEndDate(date)
					onChangeEndDate(date)
					if (onFilterChanged) {
						onFilterChanged(columnDef.tableData.id, {
							startDate: startDate,
							endDate: date
						})
					}
				}}
				minDate={startDate? startDate: new Date(2022, 0, 1)}
				maxDate={new Date()}
				materialTable={materialTable}
				zIndexVal={2}
			/>
		</div>
	</IntlProvider>
}

export default MTDateRangePicker;